//imports
import {
    BRANDS_OVERVIEW_GET_DATA_REQUEST,
    BRANDS_OVERVIEW_GET_DATA_RESULT,
} from 'Redux/actionTypes';

export const brandgetDataRequest = (data) => ({
    type: BRANDS_OVERVIEW_GET_DATA_REQUEST,
    payload: data,
});

export const brandgetDataResult = (result) => ({
    type: BRANDS_OVERVIEW_GET_DATA_RESULT,
    payload: result
});